import React from 'react';
import Invoice from 'screens/Invoices/Invoice';
import InvoiceRouteAdmin, {
  InvoiceFlow
} from 'screens/Invoices/redesign/InvoiceRouteAdmin';
import useInvoiceFlags from 'screens/Invoices/redesign/hooks/useInvoiceFlags';

/**
 * Route guard for `/app/invoices/create`.
 *
 * When the redesign flag is active the new multi-step create flow is rendered
 * via InvoiceRouteAdmin.  When the flag is off the legacy Invoice component
 * handles the request (it reads location state to determine its mode).
 */
const InvoiceCreateGuard: React.FC = () => {
  const { feInvoicesActive } = useInvoiceFlags();

  if (feInvoicesActive) {
    return <InvoiceRouteAdmin flow={InvoiceFlow.CREATE} />;
  }

  return <Invoice />;
};

export default InvoiceCreateGuard;
